import { styled } from '@mui/material/styles';

export const EmptyStateRootStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  textAlign: 'center',
  borderRadius: theme.spacing(1),
  color: theme.palette.text.secondary,
}));

export const EmptyStateIconStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.disabled,
  marginBottom: theme.spacing(0.5),
}));
